import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import InputAuto from '../../helpers/input-auto';
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error'
import { validateEmail, validatePhone } from '../../helpers/common';



const FacilityInformation = ({ work_order, onWorkOrderChange, is_loading = true,  readOnly = false  }) => {
    const navigate = useNavigate();
    const role = parseInt(localStorage.getItem('@admin_role'), 10);
    const [facility, setFacility] = useState({
        facility_id: "",
        facility_name: "",
        facility_attn: "",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        facility_zip: "",
        facility_contact_name: "",
        facility_contact_phone: "",
        facility_contact_fax: "",
        facility_contact_email: "",
        facility_fee: "",
        facility_phone: "",
        facility_fax: "",
        facility_time_zone: "",
        facility_notes: "",
        facility_internal_notes: "",
        blank_authorization: null,
        blank_authorization_sample: null

    });
    const [facilityAdd, setFacilityAdd] = useState({
        facility_id: "",
        facility_name: "",
        facility_attn: "MEDICAL RECORDS",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        facility_zip: "",
        facility_contact_name: "",
        facility_contact_phone: "",
        facility_contact_fax: "",
        facility_contact_email: "",
        facility_fee: "",
        facility_phone: "",
        facility_fax: "",
        facility_time_zone: "",
        facility_notes: "",
        facility_internal_notes: "",
        blank_authorization: null,
        blank_authorization_sample: null

    });
    const [blankAuthorization, setBlankAuthorization] = useState(null);
    const [blankAuthorizationSample, setBlankAuthorizationSample] = useState(null);
    const [facilitiesNames, setFacilitiesNames] = useState([])
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [facilitySearch, setFacilitySearch] = useState({
        facility_name: "",
        facility_address: "",
        facility_city: "",
        facility_state: "",
        client_zip: "",
    });
    const [isSearchFacilityModalOpen, setIsSearchFacilityModalOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(null);
    const [advanceSearchResults, setAdvanceSearchResults] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [addMode, setAddMode] = useState(false);

    const [rejectMode, setRejectMode] = useState(0);


    useEffect(() => {

        getFacilitiesNames();

    }, []);



    useEffect(() => {
        if (work_order?.facility_id > 0) {
            getFacility(work_order?.facility_id);
        }

    }, [work_order?.facility_id]);



    const getFacilitiesNames = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facilities-names", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacilitiesNames(response?.data?.facilities);

            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getFacility = async (facility_id) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-by-id/" + facility_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status && response?.data?.facility) {

                setFacility(response?.data?.facility);
                setIsSearchFacilityModalOpen(false);
                setEditMode(false);
                setAddMode(false);

            } else if (response?.data?.status)  {

                Swal.fire({ icon: "error", title: "Facility Info", text: "Facility record does not exist." });

            }else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const addFacilityToWorkOrder = async (facility) => {

        setSearchResults(null);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-facility-to-work-order",
            {
                work_order_id: work_order?.work_order_id,
                facility_id: facility.facility_id,
                rejectMode: rejectMode
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setFacility(response?.data?.facility);
                    let t = { facility_id: response?.data?.facility.facility_id };
                    if (rejectMode == 1 && work_order?.status == .5) {
                        t.status = 1;
                    }
                    onWorkOrderChange(t);
                    setIsSearchFacilityModalOpen(false);
                    setEditMode(false);
                    setAddMode(false);


                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });




    }


    const saveFacility = async (e) => {

        setIsBtn(true);

        const { facility_name, facility_attn, facility_time_zone, facility_address, facility_city, facility_state, facility_zip, facility_phone, facility_fax, facility_contact_email, facility_contact_fax, facility_contact_phone } = facilityAdd;
        if (!facility_name || !facility_attn || !facility_time_zone || !facility_address || !facility_city || !facility_state || !facility_zip || !facility_phone
            || !validatePhone(facility_phone) || !validatePhone(facility_fax) || !validatePhone(facility_contact_phone) || !validatePhone(facility_contact_fax) || !validateEmail(facility_contact_email)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_name: facilityAdd.facility_name,
                facility_attn: facilityAdd.facility_attn,
                facility_address: facilityAdd.facility_address,
                facility_city: facilityAdd.facility_city,
                facility_state: facilityAdd.facility_state,
                facility_zip: facilityAdd.facility_zip,
                facility_contact_name: facilityAdd.facility_contact_name,
                facility_contact_phone: facilityAdd.facility_contact_phone,
                facility_contact_fax: facilityAdd.facility_contact_fax,
                facility_contact_email: facilityAdd.facility_contact_email,
                facility_phone: facilityAdd.facility_phone,
                facility_fax: facilityAdd.facility_fax,
                facility_fee: facilityAdd.facility_attn,
                facility_time_zone: facilityAdd.facility_time_zone,
                facility_notes: facilityAdd.facility_notes,
                facility_internal_notes: facilityAdd.facility_internal_notes,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    facility_info.facility_id = response?.data?.facility_id;
                    setFacility(facility_info);
                    addFacilityToWorkOrder(facility_info);

                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

                }
                setIsBtn(false)
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)


            });

        }
    }


    const updateFacility = async (e) => {

        setIsBtn(true);

        const { facility_name, facility_attn, facility_time_zone, facility_address, facility_city, facility_state, facility_zip, facility_phone, facility_fax, facility_contact_email, facility_contact_phone } = facility;
        if (!facility_name || !facility_attn || !facility_time_zone || !facility_address || !facility_city || !facility_state || !facility_zip || !facility_phone
            || !validatePhone(facility_phone) || !validatePhone(facility_fax) || !validatePhone(facility_contact_phone) || !validateEmail(facility_contact_email)) {


            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_id: facility.facility_id,
                facility_name: facility.facility_name,
                facility_attn: facility.facility_attn,
                facility_address: facility.facility_address,
                facility_city: facility.facility_city,
                facility_state: facility.facility_state,
                facility_zip: facility.facility_zip,
                facility_contact_name: facility.facility_contact_name,
                facility_contact_phone: facility.facility_contact_phone,
                facility_contact_fax: facility.facility_contact_fax,
                facility_contact_email: facility.facility_contact_email,
                facility_phone: facility.facility_phone,
                facility_fax: facility.facility_fax,
                facility_time_zone: facility.facility_time_zone,
                facility_notes: facility.facility_notes,
                facility_internal_notes: facility.facility_internal_notes,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setFacility(facility_info);
                    setEditMode(false)

                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }



    const searchFacility = (facility_name = "", limit = 20, type = 2) => {

        var search_elements = {}
        if (facility_name != "") {
            search_elements.facility_name = facility_name;
        }
        else if (type == 1) {
            search_elements.facility_name = facilityAdd.facility_name;
            search_elements.facility_contact_name = facilityAdd.facility_contact_name;
            search_elements.facility_address = facilityAdd.facility_address;
            search_elements.facility_city = facilityAdd.facility_city;
            search_elements.facility_state = facilityAdd.facility_state;

        }
        else {
            search_elements.facility_name = facility.facility_name;
            search_elements.facility_contact_name = facility.facility_contact_name;
            search_elements.facility_address = facility.facility_address;
            search_elements.facility_city = facility.facility_city;
            search_elements.facility_state = facility.facility_state;
        }
        search_elements.limit = limit;

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-facilities", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                let searched_facilities = (
                    <>
                        <ul className="search-results-ul">
                            {response?.data?.facilities?.map((p) => (
                                <li key={p.id} onClick={() => addFacilityToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                            ))}
                        </ul>
                    </>
                );
                setSearchResults(searched_facilities);

            }
            else {
                setSearchResults(null);

            }

        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)


        });


    }

    const advanceSearchFacility = (facility_name = "") => {

        setIsBtn(true);
        var search_elements = {}
        if (facility_name != "") {
            search_elements.facility_name = facility_name;
        }

        else {
            search_elements.facility_name = facilitySearch.facility_name;
            search_elements.facility_contact_name = facilitySearch.facility_contact_name;
            search_elements.facility_address = facilitySearch.facility_address;
            search_elements.facility_city = facilitySearch.facility_city;
            search_elements.facility_state = facilitySearch.facility_state;
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-facilities", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                let searched_facilities = null;
                if (response?.data?.facilities?.length > 0) {
                    searched_facilities = (
                        <>

                            <ul className="search-results-ul">
                                {response?.data?.facilities?.map((p) => (
                                    <li key={p.id} onClick={() => addFacilityToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                                ))}
                            </ul>
                        </>
                    );
                }
                setAdvanceSearchResults(searched_facilities);

            }
            else {
                setAdvanceSearchResults(null);

            }
            setIsBtn(false);
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)


        });


    }

    const resetSearchFacility = () => {

        setFacilitySearch({
            facility_name: "",
            facility_contact_name: "",
            facility_address: "",
            facility_city: "",
            facility_state: "",
        });

    }

    const resetFacilityAdd = () => {

        setFacilityAdd({
            facility_id: "",
            facility_name: "",
            facility_attn: "MEDICAL RECORDS",
            facility_address: "",
            facility_city: "",
            facility_state: "",
            facility_zip: "",
            facility_contact_name: "",
            facility_contact_phone: "",
            facility_contact_fax: "",
            facility_contact_email: "",
            facility_fee: "",
            facility_phone: "",
            facility_fax: "",
            facility_time_zone: "",
            facility_notes: "",
            facility_internal_notes: ""
        });

    }

// Helper function to save a record into tblfacilitylogs via backend
const saveFacilityLog = async (workOrderId, facilityRecord) => {
    try {
        await axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-facility-log",
            {
                work_order_id: workOrderId,
                facility_info: JSON.stringify(facilityRecord),
            },
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );
    } catch (error) {
        console.error("Failed to save facility log", error);
    }
};

    const approveFacility = async (e) => {

        setIsBtn(true);
        if (!facility?.facility_id || !work_order?.work_order_id) {

            setInputError(true);
            setIsBtn(false);

        } else {

            saveFacilityLog(work_order.work_order_id, facility);
            var facility_info = {
                status: 1,
                work_order_id: work_order.work_order_id,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-status", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    onWorkOrderChange({ status: 1 });

                } else {
                    Swal.fire({ icon: "error", title: "Facility", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }



    const rejectAddNewFacility = async (e) => {


        setRejectMode(1);
        setAddMode(true);
        saveFacilityLog(work_order?.work_order_id, facility);

    }


    const rejectAssignExistingFacility = async (e) => {


        setRejectMode(1);
        setIsSearchFacilityModalOpen(true);
        saveFacilityLog(work_order?.work_order_id, facility);


    }






    const addBlankAuthorization = async () => {

        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            blank_authorization: blankAuthorization,
        }


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-blank-authorization", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                //setFacility({ ...facility, blank_authorization: response?.data?.blank_authorization }) 
                onWorkOrderChange({ blank_authorization: response?.data?.blank_authorization });
                setBlankAuthorization(null);

            } else {

                Swal.fire({ icon: "error", title: "Facility Special Authorization Failed to Upload", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

            }
            setIsBtn(false);

        }).catch(function (error) {

            catchError(error, navigate)


        });


    }



    const removeBlankAuthorization = async (e) => {


        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-blank-authorization",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setBlankAuthorization(null);
                    //  setFacility({ ...facility, blank_authorization: null })
                    onWorkOrderChange({ blank_authorization: null });


                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }



    const addBlankAuthorizationSample = async () => {

        setIsBtn(true);
        let auth = {
            facility_id: facility.facility_id,
            blank_authorization_sample: blankAuthorizationSample,
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-blank-authorization-sample", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacility({ ...facility, blank_authorization_sample: response?.data?.blank_authorization_sample });
                //onWorkOrderChange({ blank_authorization_sample: response?.data?.blank_authorization_sample });
                setBlankAuthorizationSample(null);

            } else {

                Swal.fire({ icon: "error", title: "Facility Blank Authorization Failed to Upload", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

            }
            setIsBtn(false);

        }).catch(function (error) {

            catchError(error, navigate)


        });


    }



    const removeBlankAuthorizationSample = async (e) => {


        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-blank-authorization-sample",
            {
                facility_id: facility.facility_id,
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setBlankAuthorizationSample(null);
                    setFacility({ ...facility, blank_authorization_sample  : null })
                    //onWorkOrderChange({ blank_authorization_sample: null });


                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
                }
                setIsBtn(false)


            }).catch(function (error) {
                catchError(error, navigate)

            });



    }


    return (
        <>
            <div className="card card-form  h-100 " >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0 " >
                        <div className="col-md-5 col-sm-12 py-2 ps-3"> 
                             <h6 className=" fw-bold text-dark mt-2">FACILITY INFORMATION</h6></div>

                        {work_order?.status < 7 && !readOnly && role >= 0 && 
                            <div className="col-md-7 col-sm-12 text-md-end -2 my-2">
                                {(work_order?.status == .5 && !addMode ) ?
                                    <>
                                        <button onClick={() => approveFacility()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "Approve"}</button>
                                        <button onClick={() => rejectAddNewFacility()} className="btn btn-sm  btn-warning me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "Reject/Add New"}</button>
                                        <button onClick={() => rejectAssignExistingFacility()} className="btn btn-sm  btn-danger me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "Reject/Assign Existing"}</button>
                                    </>
                                    :
                                    <>
                                        {addMode ?
                                            <>
                                                <button onClick={() => saveFacility()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                                <button onClick={() => { setAddMode(false); resetFacilityAdd(); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                                <button onClick={() => searchFacility("", 5, 1)} className="btn btn-sm btn-danger mx-1" type="button">SCAN </button>
                                            </>
                                            :
                                            <>
                                                {editMode ?
                                                    <>
                                                        <button onClick={() => updateFacility()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                        <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 mt-1" type="button">CANCEL UPDATE</button>
                                                    </>

                                                    :
                                                    <>
                                                        <button onClick={() => { resetFacilityAdd(); setAddMode(true) }} className="btn btn-sm  btn-success me-1 mt-1" type="button">NEW</button>
                                                        <button onClick={() => { resetSearchFacility(); setIsSearchFacilityModalOpen(true); setAdvanceSearchResults(null); setSearchResults() }} className="btn btn-sm btn-warning me-1 mt-1" type="button">ASSIGN EXISTING</button>
                                                        {(work_order?.facility_id > 0) &&
                                                            <>
                                                                <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-danger me-1 mt-1" type="button">EDIT</button>
                                                                       <a href = {`/admin/report-work-orders-facility/${work_order.facility_id}`} className="btn btn-sm btn-info me-1 mt-1" target="_blank">REPORT</a>

                                                                {/*  <button onClick={() => toggleFacilityMask()} className="btn btn-sm btn-info mx-1" type="button">{facilityMask ? "Un-mask" : "Mask"} </button>  */}
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }

                                    </>}





                            </div>
                        }
                    </div>




                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :
                        <>
                            {(work_order?.facility_id > 0 || addMode) ?

                                <form id="frm_facility" >

                                    <div className="row " >

                                        <div className="col-xl-12 col-lg-12" >
                                            <div className="" >
                                                {(addMode) ?

                                                    <>
                                                        <div className="row px-3 py-2 gx-2 ">

                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_name" >Facility*</label>

                                                                <InputAuto name="facility_name" className="form-control" minStart="3"
                                                                    value={facilityAdd.facility_name}
                                                                    pholder=""
                                                                    data={facilitiesNames}
                                                                    field="facility_name"
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_name: e })
                                                                    }
                                                                    onSelected={(e) => {

                                                                        searchFacility(e.facility_name, 10)
                                                                    }
                                                                    }

                                                                />
                                                                {inputError && !facilityAdd.facility_name &&
                                                                    <span className="text-danger">Enter valid name</span>
                                                                }




                                                            </div>
                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_attn">ATTN</label>

                                                                <input name="facility_attn" className="form-control"
                                                                    value={facilityAdd.facility_attn}
                                                                    onFocus={() => setSearchResults(null)}

                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_attn: e.target.value })
                                                                    }

                                                                />
                                                                {inputError &&
                                                                    !facilityAdd.facility_attn && (
                                                                        <span className="text-danger">Enter valid attn</span>
                                                                    )}


                                                            </div>





                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_address">ADDRESS*</label>
                                                                <input name="facility_address" id="facility_address" type="text" className="form-control"
                                                                    value={facilityAdd.facility_address}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_address: e.target.value })
                                                                    }

                                                                />
                                                                {inputError && !facilityAdd.facility_address &&
                                                                    <span className="text-danger">Enter address</span>
                                                                }



                                                            </div>


                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_city">CITY*</label>

                                                                <input name="facility_city" id="facility_city" type="text" className="form-control"
                                                                    value={facilityAdd.facility_city}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_city: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !facilityAdd.facility_city &&
                                                                    <span className="text-danger">Enter city</span>
                                                                }


                                                            </div>


                                                            <div className="col-3 my-2">
                                                                <div className="row m-0 p-0" >
                                                                    <div className="col-5 gx-1">

                                                                        <label htmlFor="facility_state">STATE*</label>

                                                                        <input name="facility_state" id="facility_state" type="text"
                                                                            className="form-control" onFocus={() => setSearchResults(null)}
                                                                            value={facilityAdd.facility_state} onChange={(e) =>
                                                                                setFacilityAdd({ ...facilityAdd, facility_state: e.target.value })
                                                                            }
                                                                        />

                                                                        {inputError && !facilityAdd.facility_state &&
                                                                            <span className="text-danger">Enter state</span>
                                                                        }



                                                                    </div>
                                                                    <div className="col-7 gx-1">
                                                                        <label htmlFor="facility_zip">ZIP*</label>

                                                                        <input name="facility_zip" id="facility_zip" type="text"
                                                                            className="form-control" onFocus={() => setSearchResults(null)}
                                                                            value={facilityAdd.facility_zip} onChange={(e) =>
                                                                                setFacilityAdd({ ...facilityAdd, facility_zip: e.target.value })
                                                                            }
                                                                        />

                                                                        {inputError && !facilityAdd.facility_zip &&
                                                                            <span className="text-danger">Enter zip</span>
                                                                        }


                                                                    </div>
                                                                </div>
                                                            </div>



                                                            <div className="col-3 my-2">


                                                                <label htmlFor="facility_phone" >TELEPHONE*</label>

                                                                <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                                                    value={facilityAdd.facility_phone} onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_phone: e.target.value })
                                                                    }
                                                                />

                                                                {inputError && (!facilityAdd.facility_phone || !validatePhone(facilityAdd.facility_phone)) &&
                                                                    <span className="text-danger">Enter a valid phone</span>
                                                                }




                                                            </div>

                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_fax">FAX</label>

                                                                <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                                                    value={facilityAdd.facility_fax} onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_fax: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !validatePhone(facilityAdd.facility_fax) &&
                                                                    <span className="text-danger">Enter a valid fax</span>
                                                                }

                                                            </div>

                                                            <div className="col-6 my-2">
                                                                <label htmlFor="facility_time_zone">Time Zone</label>

                                                                <select name="facility_time_zone" className=" form-select"
                                                                    value={facilityAdd.facility_time_zone}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_time_zone: e.target.value })
                                                                    }
                                                                >
                                                                    <option value="" selected={(!facilityAdd.facility_time_zone || facilityAdd.facility_time_zone == "") ? "selected" : ""} ></option>
                                                                    <option value="OUS" selected={(facilityAdd.facility_time_zone == "OUS") ? "selected" : ""} >OUS - Outside The United States</option>
                                                                    <option value="EST" selected={(facilityAdd.facility_time_zone == "EST") ? "selected" : ""}>EST: Eastern Standard Time</option>
                                                                    <option value="CST" selected={(facilityAdd.facility_time_zone == "CST") ? "selected" : ""}>CST: Central Standard Time</option>
                                                                    <option value="MST" selected={(facilityAdd.facility_time_zone == "MST") ? "selected" : ""}>MST - Mountain Standard Time</option>
                                                                    <option value="PST" selected={(facilityAdd.facility_time_zone == "PST") ? "selected" : ""}>PST - Pacific Standard Time</option>
                                                                    <option value="AST" selected={(facilityAdd.facility_time_zone == "AST") ? "selected" : ""}>AST- Alaska Standard Time</option>
                                                                    <option value="HST" selected={(facilityAdd.facility_time_zone == "HST") ? "selected" : ""}>HST - Hawaii Standard Time</option>
                                                                </select>
                                                                {inputError &&
                                                                    !facilityAdd.facility_time_zone && (
                                                                        <span className="text-danger">Select time zone</span>
                                                                    )}


                                                            </div>




                                                            <div className="col-4 my-2">
                                                                <label htmlFor="facility_contact_name">CONTACT NAME</label>
                                                                <input name="facility_contact_name" id="facility_contact_name" type="text"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_contact_name: e.target.value })
                                                                    }

                                                                />


                                                            </div>
                                                            <div className="col-5 my-2">
                                                                <label htmlFor="facility_contact_email">CONTACT EMAIL</label>

                                                                <input name="facility_contact_email" id="facility_contact_email" type="text" className="form-control"
                                                                    value={facilityAdd.facility_contact_email}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_contact_email: e.target.value })
                                                                    }

                                                                />
                                                                {inputError && !validateEmail(facilityAdd.facility_contact_email) &&
                                                                    <span className="text-danger">Enter valid email</span>
                                                                }
                                                            </div>

                                                            <div className="col-3 my-2">
                                                                <label htmlFor="facility_contact_phone">CONTACT PHONE</label>

                                                                <input name="facility_contact_phone" id="facility_contact_phone" type="text" className="form-control"
                                                                    value={facilityAdd.facility_contact_phone}
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_contact_phone: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !validatePhone(facilityAdd.facility_contact_phone) &&
                                                                    <span className="text-danger">Enter a valid phone</span>
                                                                }

                                                            </div>


                                                            <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                                <label htmlFor="facility_notes">FACILITY NOTES</label>

                                                                <textarea rows="4" name="facility_notes" id="facility_notes"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_notes: e.target.value })
                                                                    }
                                                                    value={facilityAdd.facility_notes}

                                                                >
                                                                    {facilityAdd.facility_notes}
                                                                </textarea>

                                                            </div>

                                                            <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                                <label htmlFor="facility_internal_notes">INTERNAL NOTES</label>

                                                                <textarea rows="4" name="facility_internal_notes" id="facility_internal_notes"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        setFacilityAdd({ ...facilityAdd, facility_internal_notes: e.target.value })
                                                                    }
                                                                    value={facilityAdd.facility_internal_notes}

                                                                >
                                                                    {facilityAdd.facility_internal_notes}
                                                                </textarea>

                                                            </div>


                                                        </div>

                                                    </>
                                                    :

                                                    <>
                                                        {(editMode) ?

                                                            <>
                                                                <div className="row px-3 py-2 gx-2 ">

                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_name" >Facility*</label>

                                                                        <InputAuto name="facility_name" className="form-control" minStart="3"
                                                                            value={facility.facility_name}
                                                                            pholder=""
                                                                            data={facilitiesNames}
                                                                            field="facility_name"
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_name: e })
                                                                            }
                                                                            onSelected={(e) => {

                                                                                searchFacility(e.facility_name, 10)
                                                                            }
                                                                            }

                                                                        />
                                                                        {inputError && !facility.facility_name &&
                                                                            <span className="text-danger">Enter valid name</span>
                                                                        }




                                                                    </div>
                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_attn">ATTN</label>

                                                                        <input name="facility_attn" className="form-control"
                                                                            value={facility.facility_attn}
                                                                            onFocus={() => setSearchResults(null)}

                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_attn: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError &&
                                                                            !facility.facility_attn && (
                                                                                <span className="text-danger">Enter valid attn</span>
                                                                            )}


                                                                    </div>




                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_address">ADDRESS*</label>
                                                                        <input name="facility_address" id="facility_address" type="text" className="form-control"
                                                                            value={facility.facility_address}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_address: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !facility.facility_address &&
                                                                            <span className="text-danger">Enter address</span>
                                                                        }



                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_city">CITY*</label>

                                                                        <input name="facility_city" id="facility_city" type="text" className="form-control"
                                                                            value={facility.facility_city}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_city: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !facility.facility_city &&
                                                                            <span className="text-danger">Enter city</span>
                                                                        }


                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <div className="row m-0 p-0" >
                                                                            <div className="col-5 gx-1">

                                                                                <label htmlFor="facility_state">STATE*</label>

                                                                                <input name="facility_state" id="facility_state" type="text"
                                                                                    className="form-control" onFocus={() => setSearchResults(null)}
                                                                                    value={facility.facility_state} onChange={(e) =>
                                                                                        setFacility({ ...facility, facility_state: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !facility.facility_state &&
                                                                                    <span className="text-danger">Enter state</span>
                                                                                }



                                                                            </div>
                                                                            <div className="col-7 gx-1">
                                                                                <label htmlFor="facility_zip">ZIP*</label>

                                                                                <input name="facility_zip" id="facility_zip" type="text"
                                                                                    className="form-control" onFocus={() => setSearchResults(null)}
                                                                                    value={facility.facility_zip} onChange={(e) =>
                                                                                        setFacility({ ...facility, facility_zip: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !facility.facility_zip &&
                                                                                    <span className="text-danger">Enter zip</span>
                                                                                }


                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-3 my-2">


                                                                        <label htmlFor="facility_phone" >TELEPHONE*</label>

                                                                        <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                                                            value={facility.facility_phone} onChange={(e) =>
                                                                                setFacility({ ...facility, facility_phone: e.target.value })
                                                                            }
                                                                        />


                                                                        {inputError && (!facility.facility_phone || !validatePhone(facility.facility_phone)) &&
                                                                            <span className="text-danger">Enter a valid phone</span>
                                                                        }



                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_fax">FAX</label>

                                                                        <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                                                            value={facility.facility_fax} onChange={(e) =>
                                                                                setFacility({ ...facility, facility_fax: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !validatePhone(facility.facility_fax) &&
                                                                            <span className="text-danger">Enter a valid fax</span>
                                                                        }
                                                                    </div>


                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_time_zone">Time Zone</label>

                                                                        <select name="facility_time_zone" className=" form-select"
                                                                            value={facility.facility_time_zone}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_time_zone: e.target.value })
                                                                            }
                                                                        >
                                                                            <option value="" selected={(!facility.facility_time_zone || facility.facility_time_zone == "") ? "selected" : ""} ></option>
                                                                            <option value="OUS" selected={(facility.facility_time_zone == "OUS") ? "selected" : ""} >OUS - Outside The United States</option>
                                                                            <option value="EST" selected={(facility.facility_time_zone == "EST") ? "selected" : ""}>EST: Eastern Standard Time</option>
                                                                            <option value="CST" selected={(facility.facility_time_zone == "CST") ? "selected" : ""}>CST: Central Standard Time</option>
                                                                            <option value="MST" selected={(facility.facility_time_zone == "MST") ? "selected" : ""}>MST - Mountain Standard Time</option>
                                                                            <option value="PST" selected={(facility.facility_time_zone == "PST") ? "selected" : ""}>PST - Pacific Standard Time</option>
                                                                            <option value="AST" selected={(facility.facility_time_zone == "AST") ? "selected" : ""}>AST- Alaska Standard Time</option>
                                                                            <option value="HST" selected={(facility.facility_time_zone == "HST") ? "selected" : ""}>HST - Hawaii Standard Time</option>
                                                                        </select>
                                                                        {inputError &&
                                                                            !facility.facility_time_zone && (
                                                                                <span className="text-danger">Select time zone</span>
                                                                            )}


                                                                    </div>




                                                                    <div className="col-4 my-2">
                                                                        <label htmlFor="facility_contact_name">CONTACT NAME</label>
                                                                        <input name="facility_contact_name" id="facility_contact_name" type="text"
                                                                            className="form-control"
                                                                            value={facility?.facility_contact_name}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_contact_name: e.target.value })
                                                                            }

                                                                        />


                                                                    </div>
                                                                    <div className="col-5 my-2">
                                                                        <label htmlFor="facility_contact_email">CONTACT EMAIL</label>

                                                                        <input name="facility_contact_email" id="facility_contact_email" type="text" className="form-control"
                                                                            value={facility.facility_contact_email}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_contact_email: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !validateEmail(facility.facility_contact_email) &&
                                                                            <span className="text-danger">Enter valid email</span>
                                                                        }

                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_contact_phone">CONTACT PHONE</label>

                                                                        <input name="facility_contact_phone" id="facility_contact_phone" type="text" className="form-control"
                                                                            value={facility.facility_contact_phone}
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_contact_phone: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !validatePhone(facility.facility_contact_phone) &&
                                                                            <span className="text-danger">Enter a valid phone</span>
                                                                        }

                                                                    </div>


  <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                                        <label htmlFor="facility_notes">FACILITY NOTES</label>

                                                                        <textarea rows="4" name="facility_notes" id="facility_notes"
                                                                            className="form-control"
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_notes: e.target.value })
                                                                            }
                                                                            value={facility.facility_notes}

                                                                        >
                                                                            {facility.facility_notes}
                                                                        </textarea>

                                                                    </div>


                                                                    <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                                        <label htmlFor="facility_internal_notes">INTERNAL NOTES</label>

                                                                        <textarea rows="4" name="facility_internal_notes" id="facility_internal_notes"
                                                                            className="form-control"
                                                                            onChange={(e) =>
                                                                                setFacility({ ...facility, facility_internal_notes: e.target.value })
                                                                            }
                                                                            value={facility.facility_internal_notes}

                                                                        >
                                                                            {facility.facility_internal_notes}
                                                                        </textarea>

                                                                    </div>


                                                                </div>

                                                            </>
                                                            :

                                                            <>

                                                                <div className={"row px-3 py-2 gx-2 " + ((work_order?.status == .5) && "bg-warning")} >

                                                                    <div className="col-6 my-2 ">
                                                                        <label htmlFor="facility_name" >Facility</label><br />

                                                                        <label className="field-info">{facility.facility_name}</label>


                                                                    </div>
                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_attn">ATTN</label><br />

                                                                        <label className="field-info">{facility.facility_attn}</label>


                                                                    </div>




                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_address">ADDRESS</label><br />
                                                                        <label className="field-info">{facility.facility_address}</label>


                                                                    </div>
                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_city">CITY</label><br />

                                                                        <label className="field-info">{facility.facility_city}</label>



                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <div className="row" >
                                                                            <div className="col-5">

                                                                                <label htmlFor="facility_state">STATE</label><br />

                                                                                <label className="field-info">{facility.facility_state}</label>


                                                                            </div>
                                                                            <div className="col-7">
                                                                                <label htmlFor="facility_zip">ZIP</label><br />

                                                                                <label className="field-info">{facility.facility_zip}</label>


                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                    <div className="col-6 my-2">

                                                                        <label htmlFor="facility_phone" >PHONE</label><br />

                                                                        <label className="field-info">{facility.facility_phone ? facility.facility_phone : ""}</label>


                                                                    </div>


                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_fax">FAX</label><br />

                                                                        <label className="field-info">{facility.facility_fax ? facility.facility_fax : ""}</label>

                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_time_zone">TIME ZONE</label><br />

                                                                        <label className="field-info">{facility.facility_time_zone}</label>


                                                                    </div>

                                                                    <div className="col-4 my-2">
                                                                        <label htmlFor="facility_contact_name">CONTACT NAME</label><br />
                                                                        <label className="field-info tt-none">{facility.facility_contact_name ? facility.facility_contact_name : ""}</label>



                                                                    </div>
                                                                    <div className="col-5 my-2">
                                                                        <label htmlFor="facility_contact_email">CONTACT EMAIL</label><br />

                                                                        <label className="field-info tt-none">{facility.facility_contact_email ? facility.facility_contact_email : ""}</label>


                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="facility_contact_phone">CONTACT PHONE</label><br />

                                                                        <label className="field-info">{facility.facility_contact_phone ? facility.facility_contact_phone : ""}</label>



                                                                    </div>


                                                                    <div className="col-6 my-2">   

                                                                        <label htmlFor="facility_notes">FACILITY NOTES </label><br />

                                                                        <label className="field-info tt-none mx-0">{facility.facility_notes ? facility.facility_notes : ""}</label>

                                                                    </div>
                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="facility_internal_notes">INTERNAL NOTES </label><br />

                                                                        <label className="field-info tt-none mx-0">{facility.facility_internal_notes ? facility.facility_internal_notes : ""}</label>


                                                                    </div>
                                                                </div>
                                                                {(work_order && work_order?.facility_id > 0) && role >= 0 &&

                                                                    <div className="row px-3 pb-2 gx-2 ">



                                                                        <div className="col-6 mb-2 ">


                                                                            <label htmlFor="blank_authorization_sample" className="pt-2" >Blank Authorization: </label>
                                                                            {facility?.blank_authorization_sample ?
                                                                                <>
                                                                                    <label className="field-info me-4 pt-2">YES</label>
                                                                                    <div className="">
                                                                                        <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-blank-authorization-sample/" + facility.facility_id} target="_blank" >Download</a>
                                                                                      {work_order?.status < 7 && !readOnly &&    <button type="button" className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeBlankAuthorizationSample} disabled={(isBtn ) ? true : false} >{(isBtn ) ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</button>}

                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {work_order?.status < 7 && !readOnly &&

                                                                                        <div className="input-group w-auto ">
                                                                                            <input name="blank_authorization_sample" id="blank_authorization_sample" type="file" className="form-control "
                                                                                                accept="pdf/*" disabled={(isBtn || readOnly) ? true : false} onChange={(e) =>
                                                                                                    setBlankAuthorizationSample(e.target.files[0])}

                                                                                            />
                                                                                            <button type="button" className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                                                                                addBlankAuthorizationSample()} disabled={(isBtn || readOnly) ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}
                                                                                                </button>

                                                                                        </div>
                                                                                    }
                                                                                </>
                                                                            }

                                                                        </div>
                                                                        <div className="col-6 mb-2 ">

                                                                            <label htmlFor="blank_authorization" className="pt-2" >Special Authorization: </label>
                                                                            {work_order?.blank_authorization ?
                                                                                <>
                                                                                    <label className="field-info me-4 pt-2">YES</label>
                                                                                    <div className="">
                                                                                        <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-blank-authorization/" + work_order.work_order_id} target="_blank" >Download</a>
                                                                                        {work_order?.status < 7 && !readOnly &&  <button type="button" className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeBlankAuthorization} disabled={(isBtn ) ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</button>}

                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {work_order?.status < 7 && !readOnly &&

                                                                                        <div className="input-group w-auto ">
                                                                                            <input name="blank_authorization" id="blank_authorization" type="file" className="form-control "
                                                                                                accept="pdf/*" disabled={(isBtn || readOnly) ? true : false}  onChange={(e) =>
                                                                                                    setBlankAuthorization(e.target.files[0])}

                                                                                            />
                                                                                            <button type="button" className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                                                                                addBlankAuthorization()} disabled={(isBtn || readOnly) ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</button>

                                                                                        </div>
                                                                                    }
                                                                                </>
                                                                            }

                                                                        </div>
                                                                    </div>

                                                                }









                                                            </>
                                                        }

                                                    </>

                                                }












                                                {searchResults &&
                                                    <>
                                                        <div className="row mt-2">
                                                            <div className="col-12">

                                                                <div className="sub-heading px-3 py-2 fw-bold text-dark">These records already exists in our database. Click on the link to add</div>

                                                            </div>
                                                        </div>


                                                        <div className="row">
                                                            <div className="col-12 pb-3 ps-4">
                                                                {searchResults}
                                                            </div>
                                                        </div>
                                                    </>
                                                }




                                            </div>
                                        </div>






                                    </div>

                                </form>

                                :
                                <div className="row " >

                                    <div className="col-xl-12 col-lg-12 p-5" >

                                        <h5>In order to proceed with this case, please add a new or an existing facility.</h5>

                                    </div>

                                </div>
                            }
                        </>
                    }
                </div>



            </div>


            <Modal animation={false}
                show={isSearchFacilityModalOpen}
                onHide={() => { setIsSearchFacilityModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-facility-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">ADVANCE SEARCH</h3></Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content ">

                        <form className="form-horizontal form-thick"  >


                            <div className="row pb-4">

                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="facility_name" >Facility</label>
                                    <InputAuto name="facility_name" className="form-control" minStart="3"
                                        value={facilitySearch.facility_name}
                                        pholder=""
                                        data={facilitiesNames}
                                        field="facility_name"
                                        onChange={(e) =>
                                            setFacilitySearch({ ...facilitySearch, facility_name: e })
                                        }
                                        onSelected={(e) =>
                                            advanceSearchFacility(e.facility_name)
                                        }

                                    />


                                </div>



                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="facility_address">Address</label>
                                    <input name="facility_address" id="facility_address" type="text" className="form-control"
                                        value={facilitySearch.facility_address}
                                        onChange={(e) =>
                                            setFacilitySearch({ ...facilitySearch, facility_address: e.target.value })
                                        }

                                    />
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="facility_city">City</label>
                                    <input name="facility_city" id="facility_city" type="text" className="form-control"
                                        value={facilitySearch.facility_city}
                                        onChange={(e) =>
                                            setFacilitySearch({ ...facilitySearch, facility_city: e.target.value })
                                        }

                                    />

                                </div>
                            </div>

                            <div className="row pb-4">
                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="facility_state">State</label>
                                    <input name="facility_state" id="facility_state" type="text" className="form-control"
                                        value={facilitySearch.facility_state}
                                        onChange={(e) =>
                                            setFacilitySearch({ ...facilitySearch, facility_state: e.target.value })
                                        }

                                    />

                                </div>


                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="facility_contact_name">Contact Name</label>
                                    <input name="facility_contact_name" id="facility_contact_name" type="text" className="form-control"
                                        value={facilitySearch.facility_contact_name} onChange={(e) =>
                                            setFacilitySearch({ ...facilitySearch, facility_contact_name: e.target.value })
                                        }
                                    />

                                </div>

                            </div>







                            <div className="modal-footer text-center m-auto">
                                <button type='button' onClick={() => advanceSearchFacility()} className="btn btn-sm btn-lg btn-success" disabled={isBtn}>
                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                                    </div><span className="sr-only">Loading...</span></> : 'Search'}
                                </button>
                                <button type='button' className="btn btn-sm btn-warning" onClick={(e) => setIsSearchFacilityModalOpen(false)}  >Cancel</button>
                                <button className="btn btn-sm btn-danger" onClick={() => { resetFacilityAdd(); setAddMode(true); setIsSearchFacilityModalOpen(false); }} >New</button>
                            </div>
                            {advanceSearchResults &&
                                <>
                                    <div className="row">
                                        <div className="col-12 p-3 ps-4">
                                            <b>These records already exists in our database. Click on the link to add</b>
                                            {advanceSearchResults}
                                        </div>
                                    </div>
                                </>


                            }
                        </form>
                    </div>
                </Modal.Body>
            </Modal>





        </>

    );
};

export default FacilityInformation;